export default {
  width: 16,
  height: 16,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.426.47a.75.75 0 0 1 1.06 0l3.044 3.043a.75.75 0 0 1 0 1.06L5.183 14.923a.75.75 0 0 1-.408.21l-3.652.608a.75.75 0 0 1-.863-.863l.609-3.652a.75.75 0 0 1 .21-.407L11.425.47ZM2.31 11.708l-.397 2.38 2.38-.397 9.647-9.648-1.982-1.982-9.648 9.647Z" />
  `
}
